import axios from 'axios';

export function getElementOffset( el )
{

    // //console.log('el', el);
    if ( typeof el === 'string' ) {
        el = document.querySelector( el );
    }

    var rect       = el.getBoundingClientRect(),
        scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
        scrollTop  = window.pageYOffset || document.documentElement.scrollTop;

    return { top: rect.top + scrollTop, left: rect.left + scrollLeft };
}


export async function getCsrfCookie()
{

    let cookie;

    try {
        cookie = await axios.get( '/sanctum/csrf-cookie' );
    }
    catch {

    }

    return cookie;

}


export function isUserLoggedIn()
{
    return AsGlobalSettings?.isAuthenticated === true ?? false;
}

export function isUserProf()
{
    return AsGlobalSettings?.isProf === true ?? false;
}

export function isUserAuthor()
{
    return AsGlobalSettings?.user?.type === "author";
}

export function isAdult()
{
    return isUserProf() || isUserAuthor();
}

export function randomIntFromInterval( min, max )
{ // min and max included
    return Math.floor( Math.random() * (max - min + 1) + min )
}


export function addCustomEventListener( selector, event, handler )
{
    const rootElement = document.querySelector( 'body' );

    //since the root element is set to be body for our current dealings
    rootElement.addEventListener( event, function ( evt )
                                  {
                                      let targetElement = evt.target;

                                      while ( targetElement != null ) {
                                          if ( targetElement.matches( selector ) ) {

                                              // console.log('Found the target ', targetElement );
                                              handler( evt, targetElement );
                                              return;
                                          }
                                          targetElement = targetElement.parentElement;
                                          // console.log('targetElement is now ', targetElement, selector);
                                      }
                                  },
                                  true,
    );
}


/**
 *
 * @param {string}          eventName
 * @param {boolean|object}  detail
 */
export function dispatchWindowEvent( eventName, detail = false )
{

    let event;

    if ( detail ) {
        event = new CustomEvent( eventName, { detail } );
    }
    else {
        event = new CustomEvent( eventName );
    }

    console.log( '%c Event: ' + eventName + ' ', 'background: green', JSON.stringify( detail ).replace( /\\n/g, '' ) );

    // let now = new Date().getTime();
    // console.log( "dispatchWindowEvent", now );

    // if ( debug[ eventName ] && debug[ eventName ] === now )
    //     return;
    //
    // debug[ eventName ] = now;
    // console.log( "dispatch", eventName )
    window.dispatchEvent( event );
}

export function freezeBodyScroll()
{
    // https://codepen.io/geoffgraham/pen/LogERe

    // const scrollY       = document.documentElement.style.getPropertyValue( '--scroll-y' );
    const scrollY                = window.scrollY;
    const body                   = document.body;
    body.style.position          = 'fixed';
    body.style.top               = `-${ scrollY }px`;
    document.body.style.overflow = `hidden`;

    // console.log( 'FREEZING', scrollY );
}

export function unfreezeBodyScroll()
{

    const body            = document.body;
    const scrollY         = body.style.top;
    body.style.position   = '';
    body.style.top        = '';
    body.style.transition = 0;

    document.documentElement.style.scrollBehavior = 'auto';
    document.body.style.removeProperty( 'overflow' );

    window.scrollTo( {
                         top     : parseInt( scrollY || '0' ) * -1,
                         behavior: 'auto',
                     } )

    console.log( 'UNfreezing', parseInt( scrollY || '0' ) * -1 );
}


export function isPageWallBlocked()
{
    return document.body.classList.contains( 'dekcolb' );
}


// https://stackoverflow.com/a/41391872
export function wrapAll( nodes, wrapper ) {
    // Cache the current parent and previous sibling of the first node.
    var parent          = nodes[ 0 ].parentNode;
    var previousSibling = nodes[ 0 ].previousSibling;

    // Place each node in wrapper.
    //  - If nodes is an array, we must increment the index we grab from
    //    after each loop.
    //  - If nodes is a NodeList, each node is automatically removed from
    //    the NodeList when it is removed from its parent with appendChild.
    for ( var i = 0; nodes.length - i; wrapper.firstChild === nodes[ 0 ] && i++ ) {
        wrapper.appendChild( nodes[ i ] );
    }

    // Place the wrapper just after the cached previousSibling,
    // or if that is null, just before the first child.
    var nextSibling = previousSibling ? previousSibling.nextSibling : parent.firstChild;
    parent.insertBefore( wrapper, nextSibling );

    return wrapper;
}


export function unwrap( wrapper ) {
    // place childNodes in document fragment
    var docFrag = document.createDocumentFragment();
    while ( wrapper.firstChild ) {
        var child = wrapper.removeChild( wrapper.firstChild );
        docFrag.appendChild( child );
    }

    // replace wrapper with document fragment
    wrapper.parentNode.replaceChild( docFrag, wrapper );
}


export function checkIfUsingCorrectAssetsBuild( currentBuildType ) {

    console.info( 'Current Build Type = ' + currentBuildType, window.SiteMode );

    if ( typeof window.SiteMode === 'undefined' ) {
        console.error( 'Please make sure to defined MixBuildType in your template.<br><code>const MixBuildType = @json(env(\'APP_ENV\') == \'production\' ? \'PRODUCTION\' : \'DEV\');</code> ' );
        return;
    }


    if ( window.SiteMode.toUpperCase() === 'PRODUCTION' && currentBuildType.toUpperCase() !== 'PRODUCTION' ) {
        console.error( '%c⚠️ABORT! ABORT!⚠️ ' +
                       "\n" +
                       '%cUsing dev assets in production environment', 'font-size: 100px; font-weight: bold; display: block;', 'font-size: normal;' );
    }

}


export function smoothScrollToElement( element ) {

    const headerHeight = document.querySelector( '#site-header' ).getBoundingClientRect().height;


    window.scrollTo( {
                         top     : getElementOffset( element ).top - 20 - headerHeight,
                         left    : 0,
                         behavior: 'smooth',
                     } );


}


export function maybeTrimText( text, length = null, ellipsis = '...' ) {
    if ( length === null ) {
        length = parseInt( AsGlobalSettings?.copydeck?.comments?.max_username_length_displayed.fr ?? 15 );
    }

    const isTooLong = text.length > length;
    // console.log( 'maybeTrimText', text, length, text.length, isTooLong )

    if ( !isTooLong ) {
        return text;
    }


    text = text.slice( 0, length ) + ellipsis;

    return text;

}
